module.exports = __webpack_public_path__ + "static/media/questa-sans-regular.2ac5e071.woff";